import { supabase } from "./supabase-client";

/**
 * Generates a unique streaming redirect token for an event.
 * Format: {slug}-live or {slug}-live-{n} if collision occurs.
 */
export async function generateStreamingRedirectToken(slug: string): Promise<string> {
  let token = `${slug}-live`;
  let attempt = 0;

  while (true) {
    const { count } = await supabase
      .from("events")
      .select("id", { count: "exact", head: true })
      .eq("streaming_redirect_token", token);

    if (count === 0) return token;
    attempt++;
    token = `${slug}-live-${attempt}`;
  }
}
